import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { AuthGuard } from '@security/guards/auth.guard';
import { EnrolledCourseGuard } from '@security/guards/enrolled-course.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth-routes').then(m => m.routes),
  }, {
    path: 'admin',
    loadChildren: () => import('./pages/administration/administration-routes').then(m => m.routes),
    canActivateChild: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)],
    data: {auth: ['ROLE_ADMIN'], source: 'app-routes -> admin'},
  }, {
    path: 'main',
    loadChildren: () => import('./pages/main/main-routes').then(m => m.routes),
    canActivateChild: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)],
  },
  {
    path: 'documentation',
    loadChildren: () => import('./pages/documentation/documentation-routes').then(m => m.routes),
    // canActivateChild: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)],
    data: {auth: ['ROLE_TEACHER', 'ROLE_STUDENT']},
  }, {
    path: 'teaching/:courseGuid',
    loadChildren: () => import('./pages/teaching/teaching-routes').then(m => m.routes),
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(EnrolledCourseGuard).canActivate(route, state)],
    data: {auth: ['ROLE_TEACHER', 'ROLE_STUDENT']},
  },
  {
    path: 'teachers/:teacherUsername',
    loadChildren: () => import('./pages/market/market-routes').then(m => m.routes),
  },
  {
    path: '',
    loadChildren: () => import('./pages/landing/landing-routes').then(m => m.routes),
    data: {source: 'app-routes -> '}
  },
  {path: '**', redirectTo: ''}
];
